import Nullstack from 'nullstack';
export default function IconCurrencyLari({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-currency-lari",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M18 13a6 6 0 1 0 -6 6"
  }), "   ", Nullstack.element("path", {
    d: "M6 19h12"
  }), "   ", Nullstack.element("path", {
    d: "M10 5v7"
  }), "   ", Nullstack.element("path", {
    d: "M14 12v-7"
  }), " ");
}